import { citationFragment } from '../CitationCodes/fragment.query';

export const cpscEntityFragment = `
  fragment cpscEntityFields on CpscEntity {
    entityRoleCode
    entityIdentificationCode
    entityNumber
    facility {
      id
    }
    testingInclusions {
      ...citationFields
    }
    testingExclusions {
      ...citationFields
    }
    testReports {
      reportId
      reportUrl
      accessKey
    }
  }
  ${citationFragment}
`;
